import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const TableNoResultsWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;

export const TableNoResultsText = styled(typography.TitleOneRegularTypography)``;

export const TableWrapper = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: 10px;
  border-radius: 10px;
`;

export const TableGridWrapper = styled.div`
  display: grid;
  grid-template: 1fr /10fr 1fr;
  justify-items: start;
  padding: 0 24px;
`;

export const TableDivider = styled.hr`
  width: calc(100% + 48px);
  grid-column: 1 / 10;
  margin: 0 -24px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.grey003};
`;

export const TableHeader = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 15px 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const TableItem = styled.div`
  display: flex;
  flex-direction: row;
  height: 68px;
  align-items: center;
  justify-content: center;
`;

export const TableItemLink = styled(Link)`
  text-decoration: none;
`;

export const TableItemText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  ${({ rtl }) => rtl && 'direction: rtl'}
  text-decoration: none;
`;

export const TableItemSubText = styled(typography.BodyTextTwoRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const TableItemStatus = styled(typography.BodyTextTwoRegularTypography)`
  width: 150px;
  margin: 0;
  padding: 5px 0;
  text-align: center;
  border-radius: 4px;

  ${({ color, backgroundColor }) => `
    color: ${color};
    background-color: ${backgroundColor};
  `};
`;

export const TableIconBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;

  &:before {
    content: ${({ icon }) => icon};
    font-family: 'Icomoon';
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const PointsIcon = styled.span`
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.yellowMain} 2.61%,
    ${({ theme }) => theme.colors.yellowDark} 100%
  );
  border-radius: 50%;
  &::after {
    content: ${'"\\e912"'};
    position: absolute;
    font-family: 'icomoon' !important;
    font-size: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: ${({ theme }) => theme.colors.orangeDark};
  }
`;

const animation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const EmptyState = styled.div`
  padding: 50px;
  animation-name: ${animation};
  animation-duration: 2s;
`;

export const Img = styled.img`
  height: ${props => props.height || 'auto'};
  display: block;
  margin: auto;
`;

export const EmptyStateText = styled(typography.LargeTitleTypography)`
  margin: 5px 0 0 0;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  text-decoration: none;
`;

export const EmptyStateSubText = styled(typography.MediumTitleTypography)`
  margin: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.grey002};
`;
